import React from 'react';

const GreenTick = function GreenTick() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
      <path d="M3.33164 6.38112L1.19653 4.06279L0.468872 4.8425L3.33164 7.95093L9.46887 1.28703L8.75079 0.507324L3.33164 6.38112Z" fill="#1EC252" stroke="#1EC252" stroke-width="0.687676" />
    </svg>
  );
};

export default GreenTick;
